// extracted by mini-css-extract-plugin
export default {"formNewAccommodation":"newAccommodation_formNewAccommodation__9T5J6","radioButtons":"newAccommodation_radioButtons__j0gRv"};